import React from "react"
import { Link } from "gatsby"
import Loader from "../../../Loader"
import BusinessTitleCard from "../../BusinessCardTitle"
import CompanyIncorIcon from "../../../../images/business/company-incor.svg"

const Summary = (props) => {
  let {
    preferred_name1,
    preferred_name2,
    preferred_name3,
    preferred_name4,
    business_nature,
    suffix,
    address,
    country,
    state,
    city,
    category,
  } = props.businessData

  return (
    <div className="container summary">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <BusinessTitleCard
            icon={CompanyIncorIcon}
            title="Company incorporation"
            subtitle="Officially register your company or in corporation, get CAC and a TIN"
          />
          <div className="business-suport-card my-lg-5 waitlist__form p-lg-5">
            <div className="container">
              <div className="row px-lg-5">
                <div className="business-title-step_wrapper pt-5 pb-2 border-bottom">
                  <h4 className="current-step">Application Summary</h4>
                  <div className="tag">
                    <span>4 of 4</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-row position-relative">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">Value Added Service</p>
                <p className="summary-description">New Company Incorporation</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">Business Name Sample 1</p>
                <p className="summary-description">{preferred_name1}</p>
              </div>

              <div className="form-group col-lg-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">Business Name Sample 2</p>
                <p className="summary-description">{preferred_name2}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">Business Name Sample 3</p>
                <p className="summary-description">{preferred_name3}</p>
              </div>

              <div className="form-group col-lg-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">Business Name Sample 4</p>
                <p className="summary-description">{preferred_name4}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-lg-5 my-3">
                <p className="mb-1 summary-title">Business Type</p>
                <p className="summary-description">{business_nature}</p>
              </div>
            </div>

            <div className="form-row ">
              <div className="form-group col-lg-12 my-3">
                <p className="mb-1 summary-title">Business Address</p>
                <p className="summary-description">{address}</p>
              </div>
            </div>

            <hr />

            <div>
              <div className="form-row">
                <div className="form-group col-lg-6 my-3">
                  <p className="mb-1 summary-title">Position</p>
                  <p className="summary-description">
                    {props?.shareholders[0]?.shareholder_type}
                  </p>
                </div>

                <div className="form-group col-lg-5 my-3">
                  <p className="mb-1 summary-title">Full Name</p>
                  <p className="summary-description">
                    {props?.shareholders[0]?.firstname}{" "}
                    {props?.shareholders[0]?.lastname}
                  </p>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-lg-5  my-3">
                  <p className="mb-1 summary-title">Email Address</p>
                  <p className="summary-description">
                    {props?.shareholders[0]?.shareholder_email}
                  </p>
                </div>

                <div className="col-lg-5 offset-lg-1 my-3">
                  <p className="mb-1 title">Phone Number</p>
                  <p className="description">
                    {props?.shareholders[0]?.shareholder_phone}
                  </p>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-lg-5 my-3 ">
                  <p className="mb-1 summary-title">Home Address</p>
                  <p className="summary-description">
                    {props?.shareholders[0]?.shareholder_address}
                  </p>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-lg-5 my-3">
                  <p className="mb-1 summary-title">Nationality</p>
                  <p className="summary-description">
                    {props?.shareholders[0]?.nationality}
                  </p>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-lg-5 my-3">
                  <p className="mb-1 title">State</p>
                  <p className="description">
                    {props?.shareholders[0]?.shareholder_state}
                  </p>
                </div>

                <div className="col-lg-5 my-3 offset-lg-1">
                  <p className="mb-1 summary-title">City</p>
                  <p className="summary-description">
                    {props?.shareholders[0]?.shareholder_city}
                  </p>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-lg-5 my-3">
                  <p className="mb-1 title">Allotment of shares</p>
                  <p className="description">
                    {props?.shareholders[0]?.no_of_shares}
                  </p>
                </div>
              </div>

              <hr />
            </div>

            <div className="row my-5">
              {/* <div className="col-lg-5">
                <Link
                  to="/business-support/get-started"
                  className="btn sparkle--button__green_outline px-5 btn-block"
                >
                  Cancel
                </Link>
              </div> */}

              <div className="col-lg-6">
                <button
                  className="btn sparkle--button__green px-4 btn-block"
                  onClick={props.payFee}
                  disabled={props.loadingStatus}
                >
                  {!props.loadingStatus ? (
                    "Make Payment of ₦ 48,000.00"
                  ) : (
                    <>
                      <Loader width="30" color="#fff" />
                    </>
                  )}
                </button>
              </div>
            </div>

            <p className="sparkle-bright-orange text-center">
              {props.loadingStatus && "Application is in progress..."}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Summary
